import { Injectable } from '@angular/core';

export const INFLATION_CONSTRAINTS = {
  amount: { min: 100, max: 1_000_000_000, step: 100 },
  rate:   { min: 1,   max: 20,            step: 0.1 },
  years:  { min: 1,   max: 50,            step: 1   }
} as const;

export type InflationMode = 'futureCost' | 'purchasingPower';

export interface InflationYearRow {
  year: number;
  value: number;
}

export interface InflationResult {
  mode: InflationMode;
  result: number;
  years: InflationYearRow[];
}

@Injectable({ providedIn: 'root' })
export class InflationCalculatorService {

  calculate(amount: number, annualRate: number, years: number, mode: InflationMode): InflationResult {
    const r = annualRate / 100;

    const rows: InflationYearRow[] = [];
    for (let y = 0; y <= years; y++) {
      const value = mode === 'futureCost'
        ? amount * Math.pow(1 + r, y)
        : amount / Math.pow(1 + r, y);
      rows.push({ year: y, value });
    }

    return { mode, result: rows[rows.length - 1].value, years: rows };
  }
}
